module.exports = __webpack_public_path__ + "static/media/case-blue.0f075a06.png";